import type { SnapshotEntry } from '~/lib/api/types'
import styles from './expanded-detail.module.scss'

type Props = { entry: SnapshotEntry }

export function ExpandedDetail({ entry }: Props) {
  const c = entry.check_in
  if (!c) {
    return (
      <div className={styles.outer}>
        <p className={styles.empty}>No check-in details available.</p>
      </div>
    )
  }

  return (
    <div className={styles.outer}>
      <dl className={styles.grid}>
        {entry.plan_truncated && (
          <Field
            label="plan"
            value={fullPlanFromTruncated(entry.plan_truncated)}
          />
        )}
        <Field label="hours" value={c.hours_raw} mono />
        {c.mood_note && <Field label="mood note" value={c.mood_note} />}
      </dl>
    </div>
  )
}

function Field({
  label,
  value,
  mono,
}: {
  label: string
  value: string | null
  mono?: boolean
}) {
  if (!value) return null
  return (
    <>
      <dt className={styles.label}>{label}</dt>
      <dd className={`${styles.value} ${mono ? 'mono' : ''}`}>{value}</dd>
    </>
  )
}

// `plan_truncated` already lost the tail; we still render it as the
// single source the snapshot endpoint exposed. Future plans can promote
// the full check-in row out into a /people/:id detail.
function fullPlanFromTruncated(plan: string): string {
  return plan
}
